import { Box, Grid, styled, Typography } from '@mui/material';
import { type SxProps } from '@mui/material/styles';
import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  heading?: string;
  height?: string;
  paddingX?: number;
  paddingY?: number;
  showHeading?: boolean;
  containerSx?: SxProps;
  dataTestId?: string;
}

const StyledTabHeading = styled(Typography)({
  padding: 8,
  paddingLeft: 16,
  borderBottom: '1px solid #ccc',
  borderColor: 'divider',
});

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  heading,
  height = 'calc(100vh - 50px)',
  paddingX,
  paddingY,
  showHeading = true,
  containerSx,
  dataTestId,
}) => {
  if (value !== index) return;

  return (
    <Box sx={{ position: 'relative', textAlign: 'initial', ...containerSx }} data-testid={dataTestId}>
      {heading && showHeading && (
        <StyledTabHeading align="left" variant="h6">
          {' '}
          {heading}{' '}
        </StyledTabHeading>
      )}
      <Grid
        container
        height={height}
        alignContent="flex-start"
        paddingX={paddingX}
        paddingY={paddingY}
        sx={{ overflowY: 'scroll' }}
        size={12}
      >
        {children}
      </Grid>
    </Box>
  );
};

export default TabPanel;
